import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

const text = css``
const transparent = css``
const active = css``
const auto = css``
export const variantClasses = {
  text,
  transparent,
  active,
  auto,
  root: css`
    justify-content: center;
  `,

  full: css`
    width: 100%;
  `,

  outline: css`
    border: 1px solid ${cssTheme.default.day.everWhite};
    padding-inline: ${spacing(2.75)};
    padding-block: ${spacing(1.625)};

    .${text} {
      color: ${cssTheme.default.day.everWhite};
    }

    &:hover {
      border-color: ${cssTheme.default.day.everWhite};
      background: ${cssTheme.default.day.everWhite};
      transition: all 0.25s ease-out;
    }

    &:active {
      // TODO: Добавить цвет в cssTheme
      border-color: #dedede;
      background: #dedede;
      transition: all 0.15s ease-out;
    }

    &:hover,
    &:active {
      .${text} {
        color: ${cssTheme.default.day.everBlack};
      }
    }
  `,
  fill: css`
    border: 1px solid ${cssTheme.default.day.everWhite};
    background: ${cssTheme.default.day.everWhite};
    color: ${cssTheme.default.day.everBlack};
    padding-inline: ${spacing(2.75)};
    padding-block: ${spacing(1.625)};

    &:hover {
      // TODO: Добавить цвет в cssTheme
      border-color: #dedede;
      background: #dedede;
      transition: all 0.25s ease-out;
    }

    &:active {
      // TODO: Добавить цвет в cssTheme
      border-color: #bebebe;
      background: #bebebe;
      transition: all 0.15s ease-out;
    }
  `,
  pseudo: css`
    padding: 0;
    border-radius: 0;
    block-size: auto;

    .${text} {
      color: ${cssTheme.default.day.everWhite};
    }

    .${text}.${transparent} {
      // TODO: Добавить цвет в cssTheme
      color: #b1b1b1;
    }

    .${text}.${transparent}.${active} {
      color: ${cssTheme.default.day.everWhite};
    }

    &:hover,
    &:active {
      .${text} {
        // TODO: Добавить цвет в cssTheme
        color: #b3b3b3;
        transition: all 0.15s ease-out;
      }

      .${text}.${transparent} {
        color: ${cssTheme.default.day.everWhite};
        transition: all 0.15s ease-out;
      }
    }
  `,
}
